/**
 * Marcadores do modo Treino (item 5.2): aros de passagem e indicadores sobre atletas e aros. O próximo pulsa em
 * dourado, os que faltam ficam brancos e transparentes, e os já feitos somem.
 */
import * as THREE from "three";
import type { Marker } from "../training/scenario";

const COLOR = { proximo: 0xf2a541, depois: 0xffffff } as const;
const MAX = 12;

export class Markers {
  readonly root = new THREE.Group();
  private readonly rings: THREE.Mesh[] = [];

  constructor() {
    this.root.name = "Marcadores";
    const geo = new THREE.TorusGeometry(1, 0.09, 8, 40);
    for (let i = 0; i < MAX; i++) {
      const m = new THREE.Mesh(
        geo,
        new THREE.MeshBasicMaterial({
          color: COLOR.proximo,
          transparent: true,
          opacity: 0.9,
          depthWrite: false,
        }),
      );
      m.visible = false;
      m.renderOrder = 3;
      this.rings.push(m);
      this.root.add(m);
    }
  }

  /** Os aros ficam de frente para o centro do campo (no plano x), como os aros do gol. */
  update(markers: readonly Marker[], time: number): void {
    this.rings.forEach((r, i) => {
      const m = markers[i];
      if (!m || m.state === "feito") {
        r.visible = false;
        return;
      }
      r.visible = true;
      const pulse = m.state === "proximo" ? 1 + Math.sin(time * 5) * 0.06 : 1;
      r.position.set(m.position.x, m.position.y, m.position.z);
      r.scale.setScalar(m.radius * pulse);
      r.rotation.set(0, Math.PI / 2, 0);
      const mat = r.material as THREE.MeshBasicMaterial;
      mat.color.setHex(COLOR[m.state]);
      mat.opacity = m.state === "proximo" ? 0.95 : 0.45;
    });
  }

  dispose(): void {
    this.rings[0]?.geometry.dispose();
    for (const r of this.rings) (r.material as THREE.Material).dispose();
    this.root.removeFromParent();
  }
}
